<template>
    <div class="row">
        <div class="col-12 p-lr-0-sm">
            <div class="fast-actions-block pl-3 pr-3 pt-1 pb-1">
                <div class="content-crds-messages-scroll">
                    <div class="dis-flex text-blue flex-c"><label>Scanning</label></div>
                    <div class="dis-flex flex-m flex-se c-gap-5">
                        <div class="dis-flex flex-column flex-m">
                            <div class="icon-shape dis-flex flex-column">
                                <i class="fa fa-barcode fs-40 m-b--5"></i>
                            </div>
                            <small class="fs-12 mt-2">Scanner</small>
                        </div>
                        <div class="dis-flex flex-column flex-m">
                            <div class="icon-shape fs-20 dis-flex flex-column pa-3">
                                <i class="fa fa-barcode fs-24 ml-auto"></i>
                                <svg class="mr-auto" viewBox="0 0 24 24" width="1em">
                                    <path class="uim-primary" d="M5,21.99805a2.99805,2.99805,0,1,1,2.12109-.877A2.989,2.989,0,0,1,5,21.99805Z"></path>
                                    <path class="uim-primary op-0.7" d="M11,20a.99943.99943,0,0,1-1-1,5.00128,5.00128,0,0,0-5-5,1,1,0,0,1,0-2,7.0018,7.0018,0,0,1,7,7A.99943.99943,0,0,1,11,20Z"></path>
                                    <path class="uim-primary op-06" d="M15,20a.99943.99943,0,0,1-1-1,8.999,8.999,0,0,0-9-9A1,1,0,0,1,5,8,10.9995,10.9995,0,0,1,16,19,.99943.99943,0,0,1,15,20Z"></path>
                                    <path class="uim-primary op-03" d="M19,20a.99943.99943,0,0,1-1-1,13.08688,13.08688,0,0,0-3.80762-9.19238A13.08688,13.08688,0,0,0,5,6,1,1,0,0,1,5,4,15.10129,15.10129,0,0,1,15.60645,8.39355,15.10129,15.10129,0,0,1,20,19,.99943.99943,0,0,1,19,20Z"></path>
                                </svg>
                            </div>
                            <small class="fs-12 mt-2">Remote Scanner</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12 mt-3 p-lr-0-sm">
            <div class="fast-actions-block pl-3 pr-3 pt-1 pb-1">
                <div class="content-crds-messages-scroll">
                    <div class="dis-flex text-blue flex-c"><label>Operations</label></div>
                    <div class="dis-flex flex-m flex-se c-gap-5 r-gap-3">
                        <div class="dis-flex flex-column flex-m">
                            <div class="icon-shape dis-flex flex-column pos-relative">
                                <i class="text-green uis uis-circle pos-absolute fs-10" style="right:3px;top:3px;"></i>
                                <i class="uit uit-abacus fs-40"></i>
                            </div>
                            <small class="fs-12 mt-2">Start Sells</small>
                        </div>
                        <div class="dis-flex flex-column flex-m">
                            <div class="icon-shape fs-20 dis-flex flex-column pa-3">
                                <i class="uit uit-qrcode-scan fs-40"></i>
                            </div>
                            <small class="fs-12 mt-2">New User</small>
                        </div>
                        <div class="dis-flex flex-column flex-m">
                            <div class="icon-shape fs-20 dis-flex flex-column pa-3">
                                <i class="uit uit-dropbox fs-40"></i>
                            </div>
                            <small class="fs-12 mt-2">New Supply</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12 mt-3 p-lr-0-sm">
            <div class="fast-actions-block pl-3 pr-3 pt-1 pb-1">
                <div class="content-crds-messages-scroll">
                    <div class="dis-flex text-blue flex-c"><label>Documentation</label></div>
                    <div class="dis-flex flex-m flex-se flex-w c-gap-5 r-gap-3 mb-4">
                        <div class="dis-flex flex-column flex-m">
                            <div class="icon-shape dis-flex flex-column pos-relative">
                                <i class="text-green uis uis-circle pos-absolute fs-10" style="right:3px;top:3px;"></i>
                                <i class="uit uit-abacus fs-40"></i>
                            </div>
                            <small class="fs-12 mt-2">Start Sells</small>
                        </div>
                        <div class="dis-flex flex-column flex-m">
                            <div class="icon-shape fs-20 dis-flex flex-column pa-3">
                                <i class="uit uit-qrcode-scan fs-40"></i>
                            </div>
                            <small class="fs-12 mt-2">New User</small>
                        </div>
                        <div class="dis-flex flex-column flex-m">
                            <div class="icon-shape fs-20 dis-flex flex-column pa-3">
                                <i class="uit uit-dropbox fs-40"></i>
                            </div>
                            <small class="fs-12 mt-2">New Supply</small>
                        </div>
                        <div class="dis-flex flex-column flex-m">
                            <div class="icon-shape fs-20 dis-flex flex-column pa-3">
                                <i class="uit uit-dropbox fs-40"></i>
                            </div>
                            <small class="fs-12 mt-2">New Supply</small>
                        </div>
                        <div class="dis-flex flex-column flex-m">
                            <div class="icon-shape fs-20 dis-flex flex-column pa-3">
                                <i class="uit uit-dropbox fs-40"></i>
                            </div>
                            <small class="fs-12 mt-2">New Supply</small>
                        </div>
                        <div class="dis-flex flex-column flex-m">
                            <div class="icon-shape fs-20 dis-flex flex-column pa-3">
                                <i class="uit uit-dropbox fs-40"></i>
                            </div>
                            <small class="fs-12 mt-2">New Supply</small>
                        </div>
                        <div class="dis-flex flex-column flex-m">
                            <div class="icon-shape dis-flex flex-column pos-relative">
                                <i class="text-green uis uis-circle pos-absolute fs-10" style="right:3px;top:3px;"></i>
                                <i class="uit uit-abacus fs-40"></i>
                            </div>
                            <small class="fs-12 mt-2">Start Sells</small>
                        </div>
                        <div class="dis-flex flex-column flex-m">
                            <div class="icon-shape fs-20 dis-flex flex-column pa-3">
                                <i class="uit uit-qrcode-scan fs-40"></i>
                            </div>
                            <small class="fs-12 mt-2">New User</small>
                        </div>
                        <div class="dis-flex flex-column flex-m">
                            <div class="icon-shape fs-20 dis-flex flex-column pa-3">
                                <i class="uit uit-dropbox fs-40"></i>
                            </div>
                            <small class="fs-12 mt-2">New Supply</small>
                        </div>
                        <div class="dis-flex flex-column flex-m">
                            <div class="icon-shape fs-20 dis-flex flex-column pa-3">
                                <i class="uit uit-dropbox fs-40"></i>
                            </div>
                            <small class="fs-12 mt-2">New Supply</small>
                        </div>
                        <div class="dis-flex flex-column flex-m">
                            <div class="icon-shape fs-20 dis-flex flex-column pa-3">
                                <i class="uit uit-dropbox fs-40"></i>
                            </div>
                            <small class="fs-12 mt-2">New Supply</small>
                        </div>
                        <div class="dis-flex flex-column flex-m">
                            <div class="icon-shape fs-20 dis-flex flex-column pa-3">
                                <i class="uit uit-dropbox fs-40"></i>
                            </div>
                            <small class="fs-12 mt-2">New Supply</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    }
}
</script>

<style>

</style>